module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper flex-center-col"
  }, [_c('div', {
    staticClass: "droplet-container"
  }, _vm._l((_vm.quantity), function(drop) {
    return _c('i', {
      staticClass: "droplet"
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('h2', [_vm._v(_vm._s(_vm.message[_vm.counter]))]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bcf7a2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = 49
// module chunks = 0